import { PurchaseInvoiceStatus } from '@application/common/enums/purchase-invoice-status';
import { useAppSelector } from '@application/store/useStore';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function PurchaseInvoiceTabsHelpers() {
    const { unchangedPurchaseInvoice } = useAppSelector((state) => state.purchaseinvoice);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formdata, setFormData] = useState({
        id: 0,
        purchaseInvoiceNumber: 0,
        supplierId: 0,
        orderId: 0,
        workOrderId: null,
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        invoiceNumber: '',
        bookYear: 0,
        bookMonth: 0,
        invoiceAmountExclVAT: 0,
        invoiceAmountInclVAT: 0,
        note: '',
        statusId: PurchaseInvoiceStatus.Nieuw,
        invoiceFile: ''
    });
    const [errors, setErrors] = useState({
        purchaseInvoiceNumber: '',
        supplierId: '',
        invoiceNumber: '',
        invoiceDate: '',
        orderId: '',
        workOrderId: ''
    });
    useEffect(() => {
        if (!errors.purchaseInvoiceNumber && !errors.orderId && !errors.supplierId) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        if (fieldName == 'bookMonth' || fieldName == 'bookYear') {
            const updatedValue = value === '' || value === null ? 0 : parseInt(value);
            setFormData((prevData) => ({
                ...prevData,
                [fieldName]: updatedValue
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldName]: ''
            }));
        }
        else {
            setFormData((prevData) => ({
                ...prevData,
                [fieldName]: value
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldName]: ''
            }));
        }
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleUploadAttachmentChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    useEffect(() => {
        checkBoldFieldsPurchaseInvoice();
        checkUnhangedPurchaseInvoice();
    }, [formdata, unchangedPurchaseInvoice]);
    const validateForm = () => {
        const newErrors = {
            purchaseInvoiceNumber: '',
            supplierId: '',
            invoiceNumber: '',
            invoiceDate: '',
            orderId: '',
            workOrderId: ''
        };
        if (!formdata.purchaseInvoiceNumber) {
            newErrors.purchaseInvoiceNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (!formdata.orderId) {
            newErrors.orderId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        // if (!formdata.workOrderNumber) {
        //     newErrors.workOrderId = 'Dit veld is verplicht';
        // }
        if (formdata.supplierId <= 0) {
            newErrors.supplierId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Module Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isNotesTabUnsaved, setNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkUnhangedPurchaseInvoice = () => {
        if (unchangedPurchaseInvoice && formdata && id) {
            let isInfoTabUnsaved = false;
            let isNotesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedPurchaseInvoice.purchaseInvoiceNumber != formdata.purchaseInvoiceNumber ||
                unchangedPurchaseInvoice.orderId != formdata.orderId ||
                unchangedPurchaseInvoice.supplierId != formdata.supplierId ||
                unchangedPurchaseInvoice.bookYear != formdata.bookYear ||
                unchangedPurchaseInvoice.bookMonth != formdata.bookMonth ||
                unchangedPurchaseInvoice.invoiceNumber != formdata.invoiceNumber ||
                unchangedPurchaseInvoice.invoiceDate != formdata.invoiceDate ||
                unchangedPurchaseInvoice.approvedBy != formdata.approvedBy ||
                unchangedPurchaseInvoice.invoiceFile != formdata.invoiceFile) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the Notes
            if (formdata.note !== unchangedPurchaseInvoice.note) {
                isNotesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setNotesTabUnsaved(isNotesTabUnsaved);
        }
    };
    const checkBoldFieldsPurchaseInvoice = () => {
        if (formdata.purchaseInvoiceNumber ||
            formdata.orderId ||
            formdata.supplierId ||
            formdata.bookMonth ||
            formdata.bookYear ||
            formdata.note ||
            formdata.invoiceNumber ||
            formdata.invoiceDate ||
            formdata.approvedBy ||
            formdata.invoiceFile) {
            setIsInfoTabBold(true);
        }
        if (formdata.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        validateForm,
        formdata,
        errors,
        handleFieldChange,
        handleCalendarChange,
        setFormData,
        handleUploadAttachmentChange,
        infoTabErrorBorderColor,
        isNotesTabUnsaved,
        isInfoTabUnsaved,
        isInfoTabBold,
        isNotesTabBold
    };
}
